export default __webpack_public_path__ + "static/media/t4.3a283569.png";